import type { FaireCollectionEntity } from "../../entity_types/collection";

export const col_winter_folklore: FaireCollectionEntity = {
  token: "col_winter-folklore",
  type: "collection",
  name: "Winter Folklore",
  description:
    "A cozy collection inspired by Nordic traditions. Full of pattern, warmth, and wintry whimsy.",
  thumbnailUrl:
    "https://images.unsplash.com/photo-1482517967863-00e15c9b44be?w=400&h=400&fit=crop",
  heroImageUrl:
    "https://images.unsplash.com/photo-1482517967863-00e15c9b44be?w=1200&h=600&fit=crop",
  season: "winter",
  itemCount: 28,
  brandToken: "catalog_brand_audreys_home_gift",
  productTokens: [],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
